import React, { useCallback } from 'react';

import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import PropTypes from 'prop-types';

const containerStyle = {
  width: '400px',
  height: '400px',
};

const CENTER_MAP_LOCATION = {
  lng: 46.1313542,
  lat: 2.4365078,
};

const GoogleMaps = props => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const handleLoad = useCallback(map => {
    if (!map) {
      const bounds = new window.google.maps.LatLngBounds();
      map.fitBounds(bounds);
    }
  }, []);

  return (
    isLoaded && (
      <GoogleMap
        options={props.options}
        mapContainerStyle={containerStyle}
        center={props.defaultCenter}
        zoom={props.defaultZoom}
        onLoad={handleLoad}
        onClick={props.onMapClick}
      >
        {
          <Marker
            position={props.position}
            draggable={props.draggable}
            onDragEnd={props.onDragEnd}
            onCenterChanged={props.onPositionChanged}
          />
        }
      </GoogleMap>
    )
  );
};

GoogleMaps.propTypes = {
  position: PropTypes.object,
  defaultZoom: PropTypes.number,
  defaultCenter: PropTypes.object,
  containerHeight: PropTypes.string,
  onMapClick: PropTypes.func,
  draggable: PropTypes.bool,
  onDragEnd: PropTypes.func,
  options: PropTypes.object,
};

GoogleMaps.defaultProps = {
  position: {},
  defaultZoom: 11,
  defaultCenter: CENTER_MAP_LOCATION,
  containerHeight: '100%',
  onMapClick: () => null,
  draggable: true,
  onDragEnd: () => null,
  options: {},
};

export default React.memo(GoogleMaps);
